import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';
import { useEffect, useState } from 'react';
const url = process.env.REACT_APP_API_URL;
export function usePaymentHub(paymentId: string) {
  const [status, setStatus] = useState<string | null>(null);

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(`${url}/hubs/payments`)
      .withAutomaticReconnect()
      .build();

    connection.start()
      .then(() => {
        // Gå med i en grupp baserat på paymentId
        if(paymentId.length > 0){
            console.log('går med i grupp med id',paymentId)
        connection.invoke('AddToGroup', paymentId);
        }
        
      })
      .catch(console.error);

    connection.on('PaymentUpdated', (data) => {
        console.log('callback i hub',data)
      if (data.paymentReference === paymentId) {
        setStatus(data.status);
      }
    });

    return () => {
      connection.stop();
    };
  }, [paymentId]);

  return status;
}
